<div class="p-fluid">
  <div class="p-field">
    <p-selectButton
      [options]="options"
      [(ngModel)]="kreirajIf"
    >
    </p-selectButton>
  </div>
</div>
